export enum CommitAction {
    DISABLED = 'DISABLED',
    SEND_EMAIL = 'SEND_EMAIL',
    PRINT = 'PRINT',
    SEND_TO_PARENT_IFRAME = 'SEND_TO_PARENT_IFRAME',
    SEND_REQUEST = 'SEND_TO_CHILD_IFRAME',
}
